<template>
<div>
    <v-card-title>
      <v-text-field
        v-model="presearch"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="rowItems"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td  class="text-xs-left px-2">
            {{ props.item.portico_id }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.nombre }}
          </td>
          <td   class="text-xs-left px-2">
            <div v-if="props.item.force_take_photos == true">SI</div>
            <div v-else>NO</div>
          </td>
          <td  class="text-xs-left px-2">
            <v-btn outlined color="primary"
                   :to="{name: 'detalles_portico', params: {id: props.item.portico_id}}">
              Detalles
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    presearch: '',
    searchTimer: null,
    search: '',
    rowItems: [],
    pagination: {},
    totalItems: 0,
    loading: false,
    headers: [
      {
        text: 'ID', value: 'portico_id', sortable: true, width: '30%', class: 'px-2',
      },
      {
        text: 'NOMBRE PORTICO', value: 'nombre', sortable: true, width: '30%', class: 'px-2',
      },
      {
        text: 'FORZAR FOTOS', value: 'force_take_photos', sortable: true, class: 'px-2',
      },
      {
        text: 'ACCIONES', value: '', sortable: false, class: 'px-2',
      },
    ],
  }),
  created() {
    // this.getReportFromApi();
  },
  methods: {
    fetchPorticos() {
      this.loading = true;
      const { sortBy, page, rowsPerPage } = this.pagination;
      let { descending } = this.pagination;
      if (descending === null) {
        descending = false;
      }
      const formdata = {
        page,
        per_page: rowsPerPage,
        search: this.search,
        order_by: sortBy,
        descending,
      };
      this.$store.dispatch('porticos/fetchPorticos', formdata)
        .then((data) => {
          this.totalItems = data.total;
          this.rowItems = data.porticos;
          this.loading = false;
        });
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchPorticos();
      },
      deep: true,
    },
    search() {
      this.fetchPorticos();
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
};
</script>

<style scoped>

</style>
